import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, IconButton } from '@bingads-webui-react/fabric-control';

import { HelpPopupInline } from '@bingads-webui-react/help-popup';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { SparkleColor } from '../media/SparkleColor';
import { ContentView } from './content-view';
import { getChangeImageBackgroundViewStyles } from './styles/change-image-background-view-styles';
// TODO: remove mock
import { originalImgSrc } from './originalImgSrc';

const modalStyles = {
  scrollableContent: {
    display: 'flex',
    flexDirection: 'column',
  },
};

const cancelIcon = { iconName: 'Cancel' };

const iconButtonStyles = {
  root: {
    color: '#323130',
    padding: 2,
    width: 24,
    height: 24,
  },
  rootHovered: {
    color: '#201f1e',
  },
  rootPressed: {
    color: '#201f1e',
  },
};

const ChangeImageBackgroundViewImpl = ({
  editingImage,
  isOpen,
  onClose,
  onApply,
  repository,
  i18n,
  logger,
  classes,
  perfMarker,
}) => (
  <Modal
    isOpen={isOpen}
    onDismiss={() => {
      logger.logTrace('Copilot change image background - User closed the change image background modal.');
      onClose();
    }}
    containerClassName={classnames(classes.dialogRoot, 'copilot-change-image-background-view')}
    styles={modalStyles}
  >
    <div className={classes.dialogHeader}>
      <div className={classes.dialogTitleContainer}>
        <SparkleColor className="dialog-sparkle-icon" />
        <span className={classes.dialogTitleText}>{i18n.getString(_TL_('Change to a new background'))}</span >
        <HelpPopupInline topic="pop_BA_AssetLibrary_Backgrounds" />
        <div className={classes.betaIndicator}>
          <span className="beta-indicator-text">{i18n.getString(_TL_('Beta'))}</span>
        </div>
      </div>
      <IconButton
        styles={iconButtonStyles}
        iconProps={cancelIcon}
        ariaLabel="Close popup modal"
        onClick={onClose}
      />
    </div>
    <div className={classes.dialogContent}>
      <ContentView
        editingImage={editingImage}
        i18n={i18n}
        repository={repository}
        logger={logger}
        onApply={onApply}
        onClose={onClose}
        perfMarker={perfMarker}
      />
    </div>
  </Modal>
);

ChangeImageBackgroundViewImpl.propTypes = {
  editingImage: PropTypes.shape({ // ImageExperienceImage
    Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    src: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }), // TODO: added back as required
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  repository: PropTypes.shape({
    removeImageBackground: PropTypes.func,
    getImageSegmentations: PropTypes.func,
    generateImageBackground: PropTypes.func,
  }).isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  perfMarker: PropTypes.shape({ }).isRequired,
  classes: PropTypes.shape({
  }).isRequired,
};

ChangeImageBackgroundViewImpl.defaultProps = {
  editingImage: {
    Id: '123',
    src: originalImgSrc,
    width: 899,
    height: 616,
  },
};

export const CopilotChangeImageBackgroundView = withDefaultStyles(
  ChangeImageBackgroundViewImpl,
  getChangeImageBackgroundViewStyles
);
